// extracted by mini-css-extract-plugin
module.exports = {"applicationFieldToggle":"cu0iQnAbLw-FYGiBaRCGi"};